import type { Vendor } from '../../../services/vendorService';

/** Service-area ids on the vendor that the caller themselves holds. */
export function vendorCallerAreaIds(
  vendor: Pick<Vendor, 'serviceAreas'>,
  callerServiceAreaIds: number[]
): number[] {
  const have = new Set(vendor.serviceAreas?.map((sa) => sa.serviceAreaId) ?? []);
  return callerServiceAreaIds.filter((id) => have.has(id));
}

/**
 * Caller's service areas the vendor is not yet approved for. Empty means the vendor is
 * already available in every area the caller can act in — no "Add to my area" action.
 */
export function missingCallerServiceAreaIds(
  vendor: Pick<Vendor, 'serviceAreas'>,
  callerServiceAreaIds: number[]
): number[] {
  const have = new Set(vendor.serviceAreas?.map((sa) => sa.serviceAreaId) ?? []);
  return callerServiceAreaIds.filter((id) => !have.has(id));
}

export function vendorIsInCallerArea(
  vendor: Pick<Vendor, 'serviceAreas'>,
  callerServiceAreaIds: number[]
): boolean {
  return vendorCallerAreaIds(vendor, callerServiceAreaIds).length > 0;
}
